// extracted by mini-css-extract-plugin
module.exports = {"required":"MantineInputWrapper_required__KGecu"};